module.exports = __webpack_public_path__ + "static/chilli-beans-4-2899e1d752c1e9882857bc49d90273f0.jpg";